import { useEffect } from 'react';
import nProgress from 'nprogress';

export function useNProgress() {
  useEffect(() => {
    nProgress.start();

    return () => {
      setTimeout(() => nProgress.done(), 1000);
    };
  }, []);
}
